import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { sendRichMessage } from '../../utils/sendRichMessage';

const isValidDate = (day, month, year) => {
  const date = new Date(`${year}-${month}-${day}`);
  return (
    date.getDate() === parseInt(day) &&
    date.getMonth() + 1 === parseInt(month) &&
    date.getFullYear() === parseInt(year)
  );
};

const isInFuture = (day, month, year) => {
  const inputDate = new Date(`${year}-${month}-${day}`);
  const today = new Date();
  return inputDate > today;
};

const isTooOld = (year) => {
  return year < 1900;
};

const DOBInputSeparate = () => {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const { ui } = useSelector(state=>state);
  const RmConfigs = ui?.config?.attributes.RichMediaConfigs;

console.log(RmConfigs);
  const reduxState = useSelector(state => state);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const handleDayChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 2) {
      setDay(value);
      if (value.length === 2) {
        monthRef.current?.focus();
      }
    }
    setError('');
  };

  const handleMonthChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 2) {
      setMonth(value);
      if (value.length === 2) {
        yearRef.current?.focus();
      }
    }
    setError('');
  };

  const handleYearChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 4) setYear(value);
    setError('');
  };

  const validateDOB = () => {
    if (!day || !month || !year) {
      setError(RmConfigs.RichmediaDOBIncompleteFieldErrorMessage);
      return false;
    }

    if (parseInt(day) < 1 || parseInt(day) > 31) {
      setError(RmConfigs.RichmediaDOBDayErrorMessage);
      return false;
    }

    if (parseInt(month) < 1 || parseInt(month) > 12) {
      setError(RmConfigs.RichmediaDOBMonthErrorMessage);
      return false;
    }

    if (year.length !== 4) {
      setError(RmConfigs.RichmediaDOBYearErrorMessage);
      return false;
    }

    if (!isValidDate(day, month, year)) {
      setError(RmConfigs.RichmediaDOBInvalidDateErrorMessage);
      return false;
    }

    if (isInFuture(day, month, year)) {
      setError(RmConfigs.RichmediaDOBFutureErrorMessage);
      return false;
    }

    if (isTooOld(parseInt(year))) {
      setError(RmConfigs.RichmediaDOBOldErrorMessage);
      return false;
    }

    // ✅ Add 18-year-old validation
    const birthDate = new Date(year, month - 1, day); // JS months are 0-indexed
    const today = new Date();
    const ageDiff = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  
    const age = hasHadBirthdayThisYear ? ageDiff : ageDiff - 1;
  
    if (age < 18) {
      setError(RmConfigs.RichmediaDOBAgeErrorMessage);
      return false;
    }
  
    setError('');
    return true;
  };

  const handleBlur = () => {
    if (day && month && year) validateDOB();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateDOB()) {
      const dob = `${month}/${day}/${year}`;
      sendRichMessage(dob, reduxState);
      setSubmitted(true); // disable button after successful submission
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexFlow: 'column',
        width: 'auto',
        textAlign: 'left',
        background: '#e5e5ea',
        padding: '12px',
        borderRadius: '12px',
        margin: '12px 12px 0 12px'
      }}
    >
      <div>
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBDayPlaceholder}
          className='rm-input'
          value={day}
          onChange={handleDayChange}
          onBlur={handleBlur}
          maxLength={2}
          style={{ width: '50px', padding: '6px' }}
          disabled={submitted}
        />
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBMonthPlaceholder}
          className='rm-input'
          value={month}
          onChange={handleMonthChange}
          onBlur={handleBlur}
          maxLength={2}
          ref={monthRef}
          style={{ width: '50px', padding: '6px' }}
          disabled={submitted}
        />
        <input
          type="text"
          inputMode="numeric"
          pattern="\d*"
          placeholder={RmConfigs.RichmediaDOBYearPlaceholder}
          className='rm-input'
          value={year}
          onChange={handleYearChange}
          onBlur={handleBlur}
          maxLength={4}
          ref={yearRef}
          style={{ width: '80px', padding: '6px' }}
          disabled={submitted}
        />
      </div>
      <button
        type="submit"
        disabled={submitted}
        className='dafabet'
        style={{
          borderColor: "transparent",
          borderRadius: "14px",
          padding: "0.4rem 2rem",
          margin: "0.5rem 0",
          backgroundColor: submitted ? "lightgray" : "#af0000",
          color: submitted ? "darkgray" : "#fff",
          textTransform: "capitalize",
          cursor: submitted ? "not-allowed" : "pointer",
        }}
      >
      提交
      </button>
      {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
    </form>
  );
};

export default DOBInputSeparate;
